module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('comment-box', {
    attrs: {
      "isOpen": false
    },
    on: {
      "reportContent": _vm.getContent
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "com-list"
  }, _vm._l((_vm.reportList), function(item, index) {
    return _c('li', {
      staticClass: "com-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), (item.userId === _vm.currentUserId) ? _c('a', {
      staticClass: "option del",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleDel(item.id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "option rep",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.report(index)
        }
      }
    }, [_vm._v("回复")])]), _vm._v(" "), _c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "width": "36",
        "height": "36",
        "src": item.userAvatar,
        "alt": item.userName
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "post-time"
    }, [_vm._v(_vm._s(item.addTime))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refUserName),
        expression: "item.refUserName"
      }],
      staticClass: "at"
    }, [_vm._v("@" + _vm._s(item.refUserName))]), _vm._v(" "), _vm._l((_vm.paragraph(item.content)), function(p) {
      return _c('p', {
        key: p,
        staticClass: "text"
      }, [_vm._v(_vm._s(p))])
    })], 2), _vm._v(" "), (_vm.currentIndex === index) ? _c('comment-box', {
      attrs: {
        "defUserId": item.userId,
        "isOpen": true
      },
      on: {
        "reportContent": _vm.getContent
      }
    }) : _vm._e()], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a389a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/report.vue
// module id = 1239
// module chunks = 82